import { gql } from "@apollo/client";

// Import the shared mutations from membership-order module
// export { SET_STRIPE_PAYMENT_INTENT_FUTURE_USAGE } from '@/modules/membership-order/hooks/useMembershipOrder/hooks/useUpdatePaymentIntentSetupFutureUsage';


export const ADD_CART_ITEM = gql`
  mutation AddItemToCart($input: [AddItemToCartInput!]!) {
    addItemToCart(input: $input) {
      success
      message
      error
    }
  }
`;

export const REMOVE_CART_ITEM = gql`
  mutation RemoveItemFromCart($cartItemId: String!) {
    removeItemFromCart(cartItemId: $cartItemId) {
      success
      message
      error
    }
  }
`;

export const CLEAR_CART = gql`
  mutation ClearCart {
    clearCart {
      success
      message
      error
    }
  }
`;
export const UPDATE_CART_ITEM = gql`
  mutation UpdateItemQuantity($input: UpdateItemQuantityInput!) {
    updateItemQuantity(input: $input) {
      error
      message
      removed
      success
    }
  }
`;

export const UPDATE_CART_ITEM_METADATA = gql`
  mutation UpdateItemMetadata($input: UpdateItemMetadataInput!) {
    updateItemMetadata(input: $input) {
      error
      success
      message
    }
  }
`;

export const CREATE_CART_ORDER = gql`
  mutation CreateCartOrder($input: CreateCartOrderInput!) {
    createCartOrder(input: $input) {
      success
      message
      clientSecret
      orderId
      error
    }
  }
`;

export const APPLY_PROMOCODE = gql`
  mutation ApplyPromocode($input: ApplyPromocodeInput!) {
    applyPromocode(input: $input) {
      success
      message
      error
    }
  }
`;

export const REMOVE_PROMOCODE = gql`
  mutation RemovePromocode {
    removePromocode {
      success
      message
      error
    }
  }
`;

export const DELETE_CHECKOUT_ATTENDEE_DETAILS = gql`
  mutation DeleteCheckoutAttendeeDetails($input: DeleteCheckoutAttendeesDetailsInput!) {
    deleteCheckoutAttendeesDetails(input: $input) {
      success
      deletedId
      message
    }
  }
`;

